import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router";
import { CKEditor } from "ckeditor4-react";

import useAxiosFile from "../../actions/useaxios";
import {
  DecryptData,
  LoadToast,
  isEmpty,
  updateToast,
} from "../../actions/common";
import Sidebar from "../../layouts/sidebar";
import Header from "../../layouts/header";
import { useLocation } from "react-router";
import { useSelector } from "react-redux";

function ContactUsDetail() {

  let data = useLocation();
  console.log("tyyyy", data);
  const search = data.search.split("=")[1];
  console.log("axios", data.search.split("=")[1]);
  const { toggle } = useSelector((state) => state.admin_panel.User);
  const axiosFile = useAxiosFile();
  const navigate = useNavigate();

  const [Data, SetData] = useState({});
  // const [disb, setDisb] = useState(false)

  const [edit, setEdit] = useState({ ReplyMessage: "" });
  const [errors, setError] = useState({});
  const [DisabledStatus, SetDisabledStatus] = useState(false);

  // setDisb({search})
  console.log("dddd", Data);
  console.log("fffff", Data.type, Data?.subject, Data?.ReplyMessage);
  useEffect(() => {
    viewdata();
  }, [data]);

  const viewdata = async () => {
    console.log("search",);
    if (!isEmpty(data?.state)) {
      SetData({
        ...data?.state
      });
    }
    if (data?.state?.ReplyMessage) {
      setEdit({ ReplyMessage: data?.state?.ReplyMessage });
    }
  };

  const OnChangeFunc = (e) => {
    setError("");

    console.log("sadfgjhadfasdf", e.target.value);
    var { name, value } = e.target;
    console.log("nv", name, value);

    SetData({ ...Data, ...{ [e.target.name]: e.target.value } });
  };

  const clickSubmit = async (e) => {
    SetDisabledStatus(true);
    let id = LoadToast();

    var value = addvalidation();

    if (!isEmpty(value)) {
      console.log("value", value);
      setError(value);
      updateToast(id, "fix all validation", "error");
    } else {
      console.log("search_data", search);
      let senddata;
      senddata = Data;
      var data = await axiosFile.ContactUsReply(senddata);
      console.log("dddd", data);
      if (data.success == "success") {
        updateToast(id, "Reply Send to their Email-Id", "success");
        console.log("statusdata", data.success);
        navigate(-1);
      }
      else {
        SetDisabledStatus(false);
        return updateToast(id, data?.msg, "error")
      }
    }
    SetDisabledStatus(false);
  };
  const ckeditfn = (evt) => {
    console.log("event", evt);
    setError("");
    var edit = evt.editor.getData();
    var name = evt.editor.name;
    console.log("edit_data", name, edit);
    SetData((editor) => ({ ...editor, [name]: edit }));
  };
  const addvalidation = () => {
    console.log("dbhjbnjhbasjhd", Data.type, Data?.subject, Data?.ReplyMessage);
    // const link = /^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/;
    let errors = {};
    if (isEmpty(Data?.ReplySubject)) {
      errors.ReplySubject = "subject field is required";
    }
    if (isEmpty(Data?.ReplyMessage)) {
      errors.ReplyMessage = "Message is required";
    }

    return errors;
  };

  console.log("Data", Data);
  return (
    <>
      <div>
        <div className="innerpages">
          <div className="orders_pages">
            <Header />
            <div className="container custom_container px-lg-0">
              <div className="row mx-auto">
                <div className="innerpages_wid px-0">
                  <Sidebar />
                  <div
                    className={
                      toggle
                        ? "ReplyMessage-sec-inner right_widthset content_without_sidebar"
                        : "ReplyMessage-sec-inner  content_with_sidebar"
                    }
                  >
                    <section id="ReplyMessage-wrapper">
                      <div className="row mx-auto">
                        <div className="col-11 col-sm-8 col-md-7 col-lg-8 col-xl-6 col-xxl-5 px-0">
                          <div>
                            <div className="top_title_sec">
                              <p className="page_title">
                                Contact Us Detail
                              </p>
                            </div>
                            <div className="mb-3">
                              <label>
                                First Name
                              </label>
                              <input
                                className="mdv_cmninput "
                                // disabled={true}
                                name="FirstName"
                                type="text"
                                id="FirstName"
                                placeholder="Given First Name"
                                value={Data?.FirstName}
                              />
                              <span id="icon-error" className="error-msg mt-2">
                                {errors && errors.FirstName}
                              </span>
                            </div>
                            <div className="mb-3">
                              <label>
                                Last Name
                              </label>
                              <input
                                className="mdv_cmninput"
                                // disabled={true}
                                name="LastName"
                                type="text"
                                id="LastName"
                                placeholder="Given Last Name"
                                value={Data?.LastName}
                              />
                              <span id="icon-error" className="error-msg mt-2">
                                {errors && errors.LastName}
                              </span>
                            </div>
                            <div className="mb-3">
                              <label>
                                Email-Id
                              </label>
                              <input
                                className="mdv_cmninput"
                                // disabled={true}
                                name="EmailId"
                                type="text"
                                id="EmailId"
                                placeholder="Given Email-Id"
                                value={Data?.EmailId}
                              />
                              <span id="icon-error" className="error-msg  mt-2">
                                {errors && errors.EmailId}
                              </span>
                            </div>
                            <div className="mb-3">

                              <label>Mobile</label>
                              <input
                                className="mdv_cmninput"
                                // disabled={true}
                                name="Mobile"
                                type="text"
                                id="Mobile"
                                placeholder="Given Mobile"
                                value={Data?.Mobile}
                              />
                              <span id="icon-error" className="error-msg  mt-2">
                                {errors && errors.Mobile}
                              </span>
                            </div>
                            <div className="mb-3">
                              <label>
                                Category
                              </label>
                              <input
                                className="mdv_cmninput mb-3"
                                // disabled={true}
                                name="Category"
                                type="text"
                                id="Category"
                                placeholder="Given Category"
                                value={Data?.Category}
                              />
                              <span id="icon-error" className="error-msg  mt-2">
                                {errors && errors.Category}
                              </span>
                            </div>

                            <div className="mb-3">
                              <label>Message</label>
                              <input
                                className="mdv_cmninput mb-3"
                                // disabled={true}
                                name="Message"
                                type="text"
                                id="Message"
                                placeholder="Enter the type"
                                value={Data?.Message}
                              />
                              <span id="icon-error" className="error-msg  mt-2">
                                {errors && errors.Message}
                              </span>
                            </div>
                            <div className="mb-3">
                              <label>Subject</label>
                              <input
                                className="mdv_cmninput mb-3"
                                name="ReplySubject"
                                type="text"
                                id="ReplySubject"
                                placeholder="Enter the subject"
                                value={Data?.ReplySubject}
                                onChange={(e) => { isEmpty(data?.state?.ReplyMessage) ? OnChangeFunc(e) : undefined }}
                              // disabled={!isEmpty(data?.state?.ReplyMessage)}
                              />
                              <span id="answer-error" className="error-msg  mt-2">
                                {errors && errors.ReplySubject}
                              </span>
                            </div>
                            <div className="mb-3">

                              {
                                isEmpty(data?.state?.ReplyMessage)
                                  ?
                                  <>
                                    {Data?._id ? (
                                      <>
                                        <label>
                                          Message:
                                        </label>
                                        <CKEditor
                                          name="ReplyMessage"
                                          initData={edit?.ReplyMessage}
                                          onChange={(e) => ckeditfn(e)}
                                          disabled={!isEmpty(data?.state?.ReplyMessage)}
                                          readOnly={!isEmpty(data?.state?.ReplyMessage)}
                                        />

                                      </>
                                    ) : (
                                      <></>
                                    )}
                                  </>
                                  :
                                  <>
                                    <label>
                                      Mail Sent:
                                    </label>
                                    <CKEditor
                                      name="ReplyMessage"
                                      initData={data?.state?.ReplyMessage}
                                      readOnly={!isEmpty(data?.state?.ReplyMessage)}
                                    />
                                  </>
                              }
                              <span id="answer-error" className="error-msg  mt-2">
                                {errors && errors.ReplyMessage}
                              </span>
                            </div>

                            <div>
                              <button
                                className="blue_btn add_deliveryprsn dp_btn_hover me-3"
                                onClick={() => navigate(-1)}
                              >
                                Back
                              </button>
                              <button
                                className="blue_btn add_deliveryprsn dp_btn_hover"
                                onClick={() => clickSubmit()}
                                disabled={!isEmpty(data?.state?.ReplyMessage) || DisabledStatus}
                              >
                                {isEmpty(data?.state?.ReplyMessage) ? "Reply" : "Reply Sent"}
                              </button>

                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    </>
  );
}

export default ContactUsDetail;
